import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LetterWriteFileListPreviewComponent } from './preview.component';

@NgModule({
  declarations: [
    LetterWriteFileListPreviewComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports:[
    LetterWriteFileListPreviewComponent,
  ]
})
export class LetterWriteFileListPreviewModule { }
